import { focusInside } from './focusable';

const INERT_MARKER = 'data-background-inert';
const LIVE_REGION_SELECTOR = '[aria-live], [role="status"], [role="alert"]';

const openedOverlays = [];

const isAnnouncing = (element) => element.matches(LIVE_REGION_SELECTOR);

const hideFromAssistiveTech = (element) => {
  element.inert = true;
  element.setAttribute('aria-hidden', 'true');
  element.setAttribute(INERT_MARKER, '');
};

export const getControllersOf = (overlay) => (
  overlay.id ? [...document.querySelectorAll(`[aria-controls~="${overlay.id}"]`)] : []
);

const hideSiblingsOf = (element, keptElements) => {
  [...element.parentElement.children].forEach((sibling) => {
    const isAlreadyHidden = sibling.inert || sibling.hasAttribute('aria-hidden');
    const keepsSomething = keptElements.some((kept) => sibling.contains(kept));

    if (sibling !== element && !isAlreadyHidden && !keepsSomething && !isAnnouncing(sibling)) {
      hideFromAssistiveTech(sibling);
    }
  });
};

const hideAroundBranchOf = (keptElement, keptElements) => {
  let element = keptElement;

  while (element.parentElement) {
    hideSiblingsOf(element, keptElements);

    element = element.parentElement;
  }
};

const showBackground = () => {
  document.querySelectorAll(`[${INERT_MARKER}]`).forEach((element) => {
    element.inert = false;
    element.removeAttribute('aria-hidden');
    element.removeAttribute(INERT_MARKER);
  });
};

export const hideBackground = () => {
  showBackground();

  const overlay = openedOverlays.at(-1);

  if (!overlay) {
    return;
  }

  const keptElements = [overlay, ...getControllersOf(overlay)];
  const outermostKept = keptElements.filter((element) => (
    !keptElements.some((other) => other !== element && other.contains(element))
  ));

  outermostKept.forEach((keptElement) => hideAroundBranchOf(keptElement, keptElements));
};

const lateArrivalsObserver = new MutationObserver(hideBackground);

export const getTopmostOverlay = () => openedOverlays.at(-1) ?? null;

export const openOverlay = (overlay) => {
  openedOverlays.push(overlay);
  showBackground();
  lateArrivalsObserver.observe(document.body, { childList: true });
};

export const revealOverlay = (overlay) => {
  focusInside(overlay);
  hideBackground();
};

export const restoreBackground = (overlay) => {
  const index = openedOverlays.lastIndexOf(overlay);

  if (index !== -1) {
    openedOverlays.splice(index, 1);
  }

  if (!openedOverlays.length) {
    lateArrivalsObserver.disconnect();
  }

  hideBackground();
};
